var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthDirectChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 325,
    viewBox: "0 0 325 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 162.5,
    r: 162.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 0C184.697 2.64695e-07 206.658 4.54751 227.03 13.362C247.402 22.1766 265.751 35.0712 280.948 51.2507C296.144 67.4302 307.864 86.5514 315.386 107.435C322.908 128.319 326.071 150.522 324.681 172.675C323.291 194.828 317.378 216.462 307.305 236.242C297.232 256.021 283.214 273.528 266.114 287.681C249.015 301.834 229.198 312.335 207.884 318.534C186.57 324.733 164.213 326.5 142.19 323.726L162.5 162.5V0Z",
    fill: "#C8048A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDirectChart);
export default __webpack_public_path__ + "static/media/health-direct-chart.45dc0efccd9e47a91dd82bb53144a936.svg";
export { ForwardRef as ReactComponent };